import React, { useMemo } from 'react'
import { useMobileRecordContext } from '../../../contexts/mobileRecordContext'
import VerticalEntry from "./verticalEntry"

const ChildRecord = ({ map, childRecord, sortedFormFields, tableHeaders, showHeaders }) => {
  const { mobileGisPdfTemplates } = useMobileRecordContext()
  const matchedTemplates = useMemo(
    () =>
      mobileGisPdfTemplates?.filter(
        (template) => template.form_id === childRecord?.form_id
      ) ?? [],
    [mobileGisPdfTemplates, childRecord]
  )

  const fieldObj = (mobileGisPdfTemplate) => ({
    label: mobileGisPdfTemplate?.name,
    data_type: 'gis_report',
    recordId: childRecord.id
  })

  return (
    <>
      {showHeaders && (
        <tr className="border-collapse border border-gray-300">
          {matchedTemplates && matchedTemplates.map(mobileGisPdfTemplate => (
            <th key={mobileGisPdfTemplate.id} className='border border-gray-300 p-2'>{mobileGisPdfTemplate.name}</th>
          ))}
          {tableHeaders.map(header => (
            <th key={header} className='border border-gray-300 p-2'>{header}</th>
          ))}
        </tr>
      )}
      <tr className='border border-gray-300'>
        {matchedTemplates && matchedTemplates.map(mobileGisPdfTemplate => (
          <VerticalEntry key={mobileGisPdfTemplate.id} report={mobileGisPdfTemplate} field={fieldObj(mobileGisPdfTemplate)} />
        ))}
        {sortedFormFields.map(field => (
          <VerticalEntry key={`${childRecord.uuid}-${field.id}`} field={field} map={[...map, childRecord.uuid]} />
        ))}
      </tr>
    </>
  )
}

export default ChildRecord
